import styled, { css } from 'styled-components';
import { IconArrowDown } from '@xingternal/icons';
import { spaceS, spaceXS, spaceXXS } from '@xingternal/tokens';
import { Flag } from '..';
// *** States ***
const stateIconDown = css `
  transform: rotate(0deg);
  transition: transform 0.2s linear;
`;
const stateIconUp = css `
  transform: rotate(-180deg);
  transition: transform 0.2s linear;
`;
// *** Components ***
const InteractiveFlag = styled(Flag) `
  cursor: pointer;
  padding-left: ${spaceS};
  padding-right: ${spaceXS};
`;
const Icon = styled(IconArrowDown) `
  margin-left: ${spaceXXS};
  ${({ $show }) => ($show ? stateIconUp : stateIconDown)}
`;
export const Styled = {
    InteractiveFlag,
    Icon,
};
//# sourceMappingURL=interactive-flag.styles.js.map